/* Second Set v3.13
   1. Sticky bar (snippets/ss-sticky-cta): its button, its photo and its offer take the visitor back up to
      "Choose your pack", which lights up briefly. Nothing is added to the cart from the bar.
   2. "Coaches and physical therapists tried it first.": arrows and a scroll bar under the cards
      (sections/ss-experts). They only show when the cards do not all fit. */
(function () {
  'use strict';
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* 1. Sticky bar ---------------------------------------------------------------- */
  function goUp(bar) {
    var link = qs('[data-scta-go]', bar);
    var id = link ? (link.getAttribute('href') || '').replace(/^#/, '') : '';
    var target = id && document.getElementById(id);
    if (!target) return false;
    var smooth = !reduced();
    var isPicker = /^pick-/.test(id);
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: isPicker ? 'start' : 'center' });
    var flash = isPicker ? target : null;
    if (flash) {
      flash.classList.remove('is-called');
      void flash.offsetWidth;
      flash.classList.add('is-called');
      setTimeout(function () { flash.classList.remove('is-called'); }, 1700);
    }
    // keyboard and screen reader users land on the selected pack
    var focus = isPicker ? (qs('input:checked', target) || qs('input', target)) : target;
    if (focus) setTimeout(function () { try { focus.focus({ preventScroll: true }); } catch (e) { /* old browsers */ } }, smooth ? 650 : 0);
    return true;
  }
  document.addEventListener('click', function (e) {
    var bar = e.target.closest('[data-scta]');
    if (!bar) return;
    var hit = e.target.closest('[data-scta-go], [data-scta-go-area]');
    if (!hit) return;
    if (goUp(bar)) e.preventDefault();
  });

  /* 2. Coaches and physios: arrows and scroll bar ---------------------------------- */
  function Carousel(ctrl) {
    var sec = ctrl.closest('.xpc') || ctrl.parentNode;
    var grid = qs('[data-xpc-grid]', sec);
    if (!grid) return;
    var thumb = qs('[data-xpc-thumb]', ctrl);
    var track = qs('[data-xpc-track]', ctrl);
    var prev = qs('[data-xpc-prev]', ctrl);
    var next = qs('[data-xpc-next]', ctrl);
    var queued = false;

    function step() {
      var card = grid.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : grid.clientWidth * 0.8;
    }
    function update() {
      queued = false;
      var max = grid.scrollWidth - grid.clientWidth;
      var over = max > 4;
      ctrl.hidden = !over;
      if (!over) return;
      var part = grid.clientWidth / grid.scrollWidth;
      var pos = Math.min(1, Math.max(0, grid.scrollLeft / max));
      thumb.style.width = (part * 100).toFixed(2) + '%';
      thumb.style.left = (pos * (1 - part) * 100).toFixed(2) + '%';
      prev.disabled = grid.scrollLeft <= 4;
      next.disabled = grid.scrollLeft >= max - 4;
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    function go(dir) { grid.scrollBy({ left: dir * step(), behavior: reduced() ? 'auto' : 'smooth' }); }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    // a click on the bar jumps there
    track.addEventListener('click', function (e) {
      var r = track.getBoundingClientRect();
      var at = (e.clientX - r.left) / r.width;
      var max = grid.scrollWidth - grid.clientWidth;
      grid.scrollTo({ left: Math.max(0, Math.min(max, at * grid.scrollWidth - grid.clientWidth / 2)), behavior: reduced() ? 'auto' : 'smooth' });
    });
    grid.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(grid);
    // "Read more" opens a card: sizes change
    grid.addEventListener('click', function () { setTimeout(queue, 50); });
    window.addEventListener('load', queue);
    update();
  }

  function init() {
    qsa('[data-xpc-ctrl]').forEach(function (c) {
      if (c._xpc) return;
      c._xpc = true;
      Carousel(c);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
